import Component from '@glimmer/component';
import mwLogoSchema from './schema.json';

export default class MwLogo extends Component {

  // Component schema for universal builder
  get componentSchema() {
    return mwLogoSchema;
  }

}
